import React from 'react'
import styles from './CustomH2.module.css'

export const CustomH2 = (props) => {
    return <h2 className={styles.header}>{props.children}</h2>
}